<script setup lang="ts">
defineProps<{ title: string; subtitle?: string }>();
</script>

<template>
  <div class="flex min-w-0 flex-col gap-[2px]">
    <h1 class="truncate text-[24px] leading-[28px] font-bold tracking-[-0.2px]">
      {{ title }}
    </h1>
    <p
      v-if="subtitle"
      class="text-encre-douce truncate text-[12px] leading-[17px] max-md:hidden"
    >
      {{ subtitle }}
    </p>
  </div>
</template>
